module.exports = __webpack_public_path__ + "img/raycullen.60a89c43.jpg";